import CommunityComponent from '../components/community/Community';

export default function Community() {
  return <CommunityComponent />;
}